import { useTakeoverContext } from 'modules/sendingPlatforms/contexts';
import styled from 'styled-components';
import { PanelHeader } from 'ui/takeOver';
import { Body2, spacing, Subtitle1, Subtitle2, textColors } from 'ui/theme';
import { formatPhoneNumber } from 'utils/phoneNumber';

const Container = styled.div`
  h5, h6 {
    margin: 0;
  }
  p {
    color: ${textColors.textSecondary};
  }
`;

const Header = styled(PanelHeader)`
  display: flex;
  flex-direction: column;
  gap: ${spacing.quarter};
  width: 100%;
  padding: ${spacing.base} ${spacing.plusHalf};
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.base};
  width: 100%;
  padding:  ${spacing.plusHalf};
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.quarter};
`;

const createSection = (header: string, value: string | string[] | undefined) =>
  value ? (
    <Section data-test={`takeover-body-section-${header.toLowerCase()}`}>
      <Subtitle2>{header}</Subtitle2>
      <Body2>
        {typeof value === 'string'
          ? value
          : value.map((website) => <div key={website}>{website}</div>)}
      </Body2>
    </Section>
  ) : null;

export const TakeoverBody = () => {
  const { metadata } = useTakeoverContext();

  return (
    <Container data-test="takeover-body">
      <Header>
        <Subtitle1>{metadata?.displayName}</Subtitle1>
        <Body2>{formatPhoneNumber(metadata?.phoneNumber)}</Body2>
      </Header>
      <Content>
        {createSection('Category', metadata?.vertical)}
        {createSection('Description', metadata?.description)}
        {createSection('Email', metadata?.email)}
        {createSection('Website', metadata?.websites)}
      </Content>
    </Container>
  );
};
